<div class="quote">
    <button mat-raised-button color="warn" id="save" class="saveExit" (click)="saveQuote()">Save & Exit</button>
    <a href="javascript:void(0)" class="pt-3" id="view" name="view" (click)="viewSummary()">View Summary</a>
</div>